import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';
import localeDe from 'vuetify/lib/locale/de'
import colors from 'vuetify/lib/util/colors';

// add components for vuetify-toast
Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.cyan.darken2,// colors.blue.darken4,
        secondary: '#2f5d77',
        accent: colors.pink.accent1,
        info: '#d4e9e9',
        error: colors.red.lighten1,
        pending: colors.orange.lighten2
      },
    },
  },
  lang: {
    locales: {de: localeDe},
    current: 'de',
  }
});
